import React from 'react';
import styled from 'styled-components';
import heroImageOne from '../../assets/homesecondpartimage1.svg';
import heroImageTwo from '../../assets/homesecondpartimage2.svg';
import heroImageThree from '../../assets/homesecondpartimage3.svg';
import heroImageFour from '../../assets/heroImageFour.png';
import heroImageFive from '../../assets/heroImageFive.png';
import PaginatiedSection from './PaginatiedSection';
import { Link } from 'react-router-dom';

export default function Secondcomp() {
 return (
  <Container>
   <Wrapper>
    <Hero />
    <InfoSection />
    <PaginatiedSection />
   </Wrapper>
  </Container>
 );
}

function Hero() {
 return (
  <HeroContainer>
   <HeroImageContainer>
    <HeroImage
     src={heroImageOne}
     alt='figure depicting sustainable development'
    ></HeroImage>
    <p>
     Fully compliant with <span>Government</span> standards and statutory bodies
    </p>
   </HeroImageContainer>

   <HeroImageContainer>
    <div className='middle'>
     <HeroImage
      src={heroImageTwo}
      alt='figure depicting sustainable development'
     ></HeroImage>
     <h4>Digitally Enabled Transparency</h4>
     <p>
      Our Zigma EPR solution helps you TRACK, and TRACE your Targets,
      Transactions and Performances
     </p>
    </div>
   </HeroImageContainer>
   <HeroImageContainer>
    <HeroImage
     src={heroImageThree}
     alt='figure depicting sustainable development'
    ></HeroImage>
    <p>
     <span>Transparent</span>, Traceable and with <span>Fully digital</span>{' '}
     system
    </p>
   </HeroImageContainer>
  </HeroContainer>
 );
}

function InfoSection() {
 return (
  <InfoContainer>
   <div>
    <div className='header'>
     <Heading>What we do</Heading>
     <Linebreak>
      <div className='part1'></div>
      <div className='part2'></div>
      <div className='part3'></div>
     </Linebreak>
    </div>
    <Content>
     <p>
      <i>
       Our proprietary technology segregates and processes Segregated
       Combustible Fractions from landfills across India that are safely
       processed by our trusted partners
      </i>
     </p>{' '}
    </Content>
    <Image src={heroImageFive} alt='hand holding a small plant' />
    <Link to='/about' target={'_blank'}>
     <div className='button'>Show More</div>
    </Link>
   </div>
   <div>
    <Image src={heroImageFour} alt='hand holding a small plant' />
   </div>
  </InfoContainer>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background: #fff;
`;

const Wrapper = styled.div`
 width: 65%;
 margin: 0 auto 8rem auto;
 padding-top: 2rem;
 @media screen and (max-width: 600px) {
  width: 100%;
 }
`;

// Hero Components
const HeroContainer = styled.div`
 width: 90%;
 margin: 0 auto;
 background: #ffffff;
 position: relative;
 box-shadow: 0px 0px 17px rgba(0, 0, 0, 0.25);
 display: flex;
 justify-content: space-between;
 /* font-family: 'Segoe UI'; */
 margin-top: -6rem;
 z-index: 100;
 .middle {
  position: absolute;
  top: 0;
  width: 30%;
  height: 120%;
  background-color: #90d62b;
  box-shadow: 0px 0px 29px rgba(0, 0, 0, 0.25);
  border-radius: 2.5rem;
  padding: 2rem;
  transform: translate(0%, -10%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
  align-items: center;
  h4 {
   width: 100%;
   color: #fff;
   font-size: 1.5rem;
   line-height: 2rem;
   font-weight: 600;
   text-align: center;
   text-transform: uppercase;
  }
  p {
   color: #fff;
   font-size: 1.4rem;
   line-height: 1.5rem;
   font-weight: 500;
   text-align: center;
   text-transform: capitalize;
  }
  img {
   width: 30%;
  }
 }
 @media screen and (max-width: 600px) {
  .middle {
   width: 40%;
   padding: 1rem;
  }
 }
`;

const HeroImageContainer = styled.div`
 width: 33%;
 height: 100%;
 padding: 2rem;
 display: flex;
 flex-direction: column;
 gap: 2rem;
 align-items: center;
 p {
  color: #645e58;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
  text-align: center;
  text-transform: capitalize;
  span {
   color: #8dc234;
  }
 }
 @media screen and (max-width: 600px) {
  width: 30%;
 }
`;

const HeroImage = styled.img`
 width: 25%;
 height: auto;
 object-fit: cover;
`;

//Info Section
const InfoContainer = styled.div`
 display: flex;
 flex-direction: row-reverse;
 align-items: center;
 width: 100%;
 justify-content: space-between;
 margin-top: 10rem;
 @media screen and (max-width: 600px) {
  flex-direction: column-reverse;
 }
 > div:first-child {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
 }
 > div:nth-child(2) {
  width: 45%;
 }
 div {
  height: 100%;
 }
 .header {
  width: fit-content;
 }
 .button {
  background: #90d62b;
  border-radius: 1rem;
  color: #e8e8e8;
  font-size: 1.5rem;
  width: fit-content;
  padding: 0.5rem 2rem;
  font-weight: 600;
  cursor: pointer;
 }
`;

const Heading = styled.h1`
 font-size: 3.2rem;
 font-weight: 700;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #404040;
`;

const Linebreak = styled.div`
 width: 50%;
 display: flex;
 gap: 0.5rem;
 margin-top: -1rem;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.5vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Content = styled.div`
 margin-top: 2rem;
 /* font-family: 'Segoe UI'; */
 color: #707070;
 text-align: justify;
 display: flex;
 flex-direction: column;
 gap: 2rem;
 h3 {
  font-size: 2.2rem;
  font-weight: 400;
  line-height: 2, 8rem;
  text-transform: capitalize;
 }
 p {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
 }
`;

const Image = styled.img`
 width: 100%;
 height: auto;
 object-fit: cover;
`;
